/* eslint max-classes-per-file: 0 */

import {
  Roadmap as Data,
  RoadmapCollection as Collection,
} from '@/typings/api/Roadmap'
import { RoadmapsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class RoadmapsTransformerParams extends TransformerParams {
  public getAll(payload: Record<string, unknown>, rawParams: Record<string, unknown>) {
    const result = super.getAll(payload, rawParams)
    const p = result.params as Record<string, Record<string, unknown>>

    const params = {
      ...p,

      region_id: p.region?.id as number,
      region: void 0,

      municipality_id: p.municipality?.id as number,
      municipality: void 0,

      school_id: p.school?.id as number,
      school: void 0,

      is_published: p.is_published?.value,
    }

    return { ...result, params }
  }
}

export class RoadmapsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new RoadmapsTransformerParams();
}
